import { Component, Input } from '@angular/core';
import { ChartData } from 'chart.js';
import { DataService } from 'src/app/services/data.service';

@Component({
  selector: 'app-piechart',
  templateUrl: './piechart.component.html',
  styleUrls: ['./piechart.component.scss'],
})
export class PiechartComponent {
  @Input() data: any;

  startDate: Date  = new Date('09-09-2023');
  endDate: Date = new Date();
  today: Date = new Date();
  graphData: any;
  genderData: any;
  chartOptions: any;

  constructor(private dataService: DataService) {}

  async ngOnInit() {
    const jsonData = await this.getDataFromArg(this.data);

    this.genderData = {
      labels: jsonData.map((item: any) => item.key),
      datasets: [
        {
          data: jsonData.map((item: any) => item.count), // Replace with actual data from MongoDB
          backgroundColor: [
            '#FACB7D',
            '#6648FF',
            '#703D94',
            '#F7517F',
            '#3F4357',
            '#16CEB9',
            '#532a7db8',
            '#2a0450b8',
            '#300a3b',
            '#2a0450',
            '#082f4e',
            '#011941',
            '#110d49',
          ],
        },
      ],
    };

    this.chartOptions = {
      plugins: {
        legend: {
          labels: {
            font: {
              size: 14,
              family: 'SSTArabic',
            },  
            color :'white'
          },
        },
      },
      scales: {
        x: {
          ticks: {
            font: {
              size: 12,
              family: 'SSTArabic',
            }, color :'white'
          },
        },
        y: {
          ticks: {
            font: {
              size: 12,
              family: 'SSTArabic',
            }, color :'white'
          },
        },
      },
    };
  }

  async getDataFromArg(data: any, startDate?: Date, endDate?: Date) {

    let managerOu: any = localStorage.getItem('managerOus');

    managerOu = managerOu ? JSON.parse(managerOu) : null;

    if (data.tag && data.tag === 'MANAGER' && managerOu && managerOu.length > 0) {
      let res = await this.dataService.postData(
        'dashboards/dynamic-aggregation',
        {
          aggregation: data.aggregation,
          tableName: data.table,
          timeRange: (startDate && endDate) ? { startDate: startDate, endDate: endDate } : null,
          managerOus: managerOu
        }
      );
      return res.data;
    } else {
      let res = await this.dataService.postData(
        'dashboards/dynamic-aggregation',
        {
          aggregation: data.aggregation,
          tableName: data.table,
          timeRange:  (startDate && endDate) ? { startDate: startDate, endDate: endDate } : null,
        }
      );
      return res.data;
    }
  }


  async makeChart(graphData: any) {
    return {
      labels: graphData.map((item: any) => item.key),
      datasets: [
        {
          data: graphData.map((item: any) => item.count), // Replace with actual data from MongoDB
          backgroundColor: [
            '#FACB7D',
            '#6648FF',
            '#703D94',
            '#F7517F',
            '#3F4357',
            '#16CEB9',
            '#532a7db8',
            '#2a0450b8',
            '#300a3b',
            '#2a0450',
            '#082f4e',
            '#011941',
            '#110d49',
          ],
        },
      ],
    };
  }

  async onDateChange() {
    this.graphData = await this.getDataFromArg(this.data, this.startDate, this.endDate);
    this.genderData = await this.makeChart(this.graphData)
  }
}
